import React from "react";
import { useParams } from "react-router-dom";
import NavigationBar from "../Shared/NavigationBar";
import NewFooter from "../Shared/NewFooter";
import UiuxDesigns from "./InnerPages/UiuxDesigns/UiuxDesigns";
import AppDevelopment from "./InnerPages/AppDevelopment/AppDevelopment";
import SoftwareDevelopment from "./InnerPages/SoftwareDevelopment/SoftwareDevelopment";
import ArtificialIntelligence from "./InnerPages/ArtificialIntelligence/ArtificialIntelligence";
import ECommerceService from "./InnerPages/ECommerceService/ECommerceService";
import QualityAssurance from "./InnerPages/QualityAssurance/QualityAssurance";

function ViewService() {
  let { id } = useParams();

  return (
    <>
      <NavigationBar />
      {id === "uiux-designs" ? (
        <UiuxDesigns />
      ) : id === "application-development" ? (
        <AppDevelopment />
      ) : id === "software-development" ? (
        <SoftwareDevelopment />
      ) : id === "ai-artificial-intelligence" ? (
        <ArtificialIntelligence />
      ) : id === "e-commerce-services" ? (
        <ECommerceService />
      ) : id === "quality-assurance" ? (
        <QualityAssurance />
      ) : (
        ""
      )}
      <NewFooter />
    </>
  );
}
export default React.memo(ViewService);
